import React, { useState, useEffect, useMemo, Fragment, useRef } from "react";
import { Helmet } from "react-helmet";
import AddrPopup from "@components/AddrPopup";
import { comma, getAddress } from '@src/util/helper'
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import LoadScript from "@util/loadScript";
import { createOrder, fakeOrder, validate, checkFileSize, createOrderNo} from "@pages/common/common";
import { emailRegex } from "@util/helper";
import { showSnackbar } from "@context/SnackbarContext";
import ConfirmDialog from '@components/ConfirmDialog'
import Footer from "@components/part/Footer";

import {
  Grid,
  Divider,
  Typography,
  useMediaQuery,
  useTheme,
  Container,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Radio,
  Button,
  Checkbox,
  RadioGroup,
  IconButton,
} from '@mui/material'
import useIndicator from '@hooks/useIndicator'
import moment from "moment";
import WebService from "@util/webService";
import FormControlContext from "@mui/material/FormControl/FormControlContext";
import { isAdmin } from "@util/helper";
import { LogoutOutlined, Person } from '@mui/icons-material'
import ArchitectureOutlined from '@mui/icons-material/ArchitectureOutlined'

const removeNonDigits = (input) => {
  return input.replace(/\D/g, '')
}

const Contract1 = () => {
  const dgRef = useRef()
  const navigate = useNavigate()
  const location = useLocation()
  const pack = location.state?.pack
  const orderFrom = pack?.data?.order
  const codes = useSelector(state => state.codeReducer)
  const productCodes = codes.filter(r => r.codeGroupId === 'R001')
  const bizCodes = codes.filter(r => r.codeGroupId === 'R002')
  const channelCodes= codes.filter(r => r.codeGroupId === 'R003')
  const {productCode} = useParams()
  // 신규 작성 시 우편물/택배 보관 기간 초과 폐기는 '동의' 를 기본값으로 (contract2 에서 돌아온 경우는 기존 선택 유지)
  // 우편물 실물 발송 서비스는 종료되어 화면에서 제외하고 항상 'N' (미신청)
  const [order, set_order] = useState({ ...(orderFrom ?? { ...createOrder(), destroySvcYn: 'Y' }), rmailSvcYn: 'N' })
  // const [order, set_order] = useState(orderFrom?? fakeOrder())
  const theme = useTheme()
  const [idFiles, set_idFiles] = useState([])
  const [bizFiles, set_bizFiles] = useState([])
  const [corpFiles, set_corpFiles] = useState([])
  const [agencyFiles, set_agencyFiles] = useState([])
  const [isLoading, set_isLoading] = useState(true)
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const inputsRef = useRef({})
  const confirmRef = useRef(null)
  const account = useSelector((state) => state.accountReducer)
  const [branches, set_branches] = useState([])
  const [branchId, set_branchId] = useState(orderFrom?.branchId ?? -1)

  for(const [key, value] of Object.entries(order)) {
    const target = {
      name:key,
      value: value
    }
    inputsRef.current[key] = target
  }

  const fetchBranches = async () => {
    const url = `/public/info`
    const resp = await WebService.get(url)
    if (resp.repCode !== 'ack') {
      showSnackbar('지점 정보를 가져올 수 없습니다.', theme.palette.warning.dark)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    const list = JSON.parse(repMessage.branches)
      .filter((b) => b.id > 0 && b.statCode === 'S001')
      .sort((a, b) => a.id - b.id)
    set_branches(list)
    // 이전에 고른 지점이 목록에 없으면 본점, 본점이 없으면 첫 지점을 기본 선택
    set_branchId((prev) => {
      if (list.some((b) => b.id === prev)) {
        return prev
      }
      return (list.find((b) => b.hqYn === 'Y') ?? list[0])?.id ?? -1
    })
  }

  const handleChange = (e) => {

    if(e.target.name === 'repPhone' || e.target.name === 'contactPhone') {
      const newVal =  removeNonDigits(e.target.value)
      inputsRef.current[e.target.name].value = newVal
    }

    if(e.target.name === 'civilNum1' || e.target.name === 'civilNum2')  {
      const newVal =  removeNonDigits(e.target.value)
      inputsRef.current[e.target.name].value = newVal
    }

    if(e.target.name === 'bizNum1' || e.target.name === 'bizNum2' || e.target.name === 'bizNum3') {
      const newVal =  removeNonDigits(e.target.value)
      inputsRef.current[e.target.name].value = newVal
    }

    if(e.target.name === 'corpNum1' || e.target.name === 'corpNum2') {
      const newVal =  removeNonDigits(e.target.value)
      inputsRef.current[e.target.name].value = newVal
    }
  }



  const fetchStartTime = async (bizNum) => {
    const url = `/public/order/start/time`
    const resp = await WebService.get(url, {
      bizNum: bizNum
    })
    if(resp.repCode != 'ack') {
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    const startTime = repMessage.startTime
    return startTime
  }

  const fillData = async () => {
    // 계약 지점 확인
    const branch = branches.find((b) => b.id === branchId)
    if (!branch) {
      showSnackbar('계약 지점을 선택해 주세요.', theme.palette.warning.dark)
      document.getElementById('branchSelect')?.focus()
      console.log('ids=>', JSON.stringify(branches.map((b) => b.id)))
      return
    }
    order.branchId = branch.id

    const ret = validate(order, inputsRef, theme, productCodes)
    if(!ret) {
      return
    }

    if(idFiles.length === 0) {
      showSnackbar('대표자 신분증을 첨부해 주세요.', theme.palette.warning.dark)
      document.getElementById('idFilesButton').focus()
      return
    }

    //
    const dateFormat = 'YYYY-MM-DD HH:mm:ss'
    const today = moment().startOf('day')
    let startTime = today.format(dateFormat)
    if(order.bizNum) {
       const tm = await fetchStartTime(order.bizNum)
       if(tm) {
          startTime = tm
       }
    }
    order.startTime = startTime

    // 개월 수는 validate() 에서 상품코드 기준으로 계산한 값 사용 (P001 6, P002 12, P003 24)
    const endTime = moment(startTime, dateFormat).add(order.month, "months").subtract(1, "seconds").format(dateFormat)
    order.endTime = endTime
    return true
  }

  const onNext = async () => {
    // contract2 소재지 표시용으로 선택한 지점 정보도 함께 전달
    const branch = branches.find((b) => b.id === order.branchId)

    navigate('/contract2', {
      state: {
        order: order,
        pack: {
          url: window.location.pathname,
          data: {
            order: order,
            branch: branch,
            idFiles: idFiles,
            bizFiles: bizFiles,
            corpFiles: corpFiles,
            agencyFiles: agencyFiles,
          }
        }
      }
    })
  }
  useEffect(() => {

    if(!productCode) {
      navigate('/')
    }
    else {
      if(!productCodes.map(r => r.code).includes(productCode)) {
        navigate('/')
      }
      order.productCode = productCode
    }
  },[])


  useEffect(() => {
    fetchBranches()
  }, [])

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    const timer = setTimeout(() => {
      set_isLoading(false);
      closeIndicator()
    }, 500);

    return () => clearTimeout(timer);
  }, []);


  if(isLoading) {
    return (
      openIndicator()
    )
  }

  return (
    <>
      <AddrPopup
        ref={dgRef}
        title={'주소검색'}
        windowWidth='sm'
        callback={(data) => {
          if(data.zonecode) {
            inputsRef.current['zipCode'].value = data.zonecode
            const addr = getAddress(data, true, true)
            inputsRef.current['addr1'].value = addr
          }
          else {
            inputsRef.current['zipCode'].value = ''
            inputsRef.current['addr1'].value = ''

          }
        }}
      />

      <Helmet>
        <script src="/src/js/main.js"></script>
      </Helmet>
      <header id="header">
        <div className="container">
          <div className="logo">
            <a href="/">
              <img src="/src/img/logo_w.svg"
                alt="비상주 오피스"
                className="white"
              />
              <img src="/src/img/logo.svg"
                alt="비상주 오피스"
                className="black"
              />
            </a>
          </div>
          <div className="gnb">
            <nav className="gnb_nav">
              <ul>
                <li>
                  <a href="#">비상주 오피스</a>
                  <div className="dropdown">
                    <a href="/home#about">비상주오피스 소개</a>
                    <a href="/home#progress">계약절차안내</a>
                    <a href="/home#contact">계약,결제하기</a>
                  </div>
                </li>
                <li>
                  <a href="/home#bundle">결합 할인 서비스</a>
                </li>
                <li>
                  <a href="/home#location">오시는 길</a>
                </li>
              </ul>
            </nav>
            <div className="inquiry">
              <a href="/home#contact">빠른 계약하기</a>
            </div>
            {
              account?.user?.id ? (
                <>
                  {
                    isAdmin(account) ? (
                      <div>
                        <IconButton onClick={() => navigate('/admin')}>
                          <ArchitectureOutlined style={{color:'#9e9e9e'}}/>
                        </IconButton>
                      </div>
                    ) : null
                  }
                  <div>
                    <IconButton onClick={() => navigate('/logout')}>
                      <LogoutOutlined style={{color:'#9e9e9e'}}/>
                    </IconButton>
                  </div>
                </>

              ) : null
            }
          </div>
          <div className="mo_btn">
            <a href="#" id="moBtn">
              <img src="/src/img/nav_on_w.svg" className="white" />
              <img src="/src/img/nav_on_b.svg" className="black" />
            </a>
          </div>
        </div>
        <div className="side_menu">
          <div className="box">
            <div className="logo">
              <a href="/">
                <img src="/src/img/logo_w.svg" alt="비상주 오피스" />
              </a>
            </div>
            <nav className="side_nav">
              <ul>
                <li>
                  <a href="#">비상주 오피스</a>
                  <div className="dropdown">
                    <a href="/home#about">비상주오피스 소개</a>
                    <a href="/home#progress">계약절차안내</a>
                    <a href="/home#contact">계약,결제하기</a>
                  </div>
                </li>
                <li>
                  <a href="/home#bundle">결합 할인 서비스</a>
                </li>
                <li>
                  <a href="/home#location">오시는 길</a>
                </li>
              </ul>
            </nav>
            <div className="inquiry">
              <a href="/home#contact">빠른 계약하기</a>
            </div>
            <a href="#" id="moCan">
              <img src="/src/img/nav_can.svg" />
            </a>
          </div>
        </div>
      </header>
      <div className="sub_banner step_2">
        <div className="container">
          <div className="text_box">
            <h2
              data-aos="fade-up"
              data-aos-duration={1500}
              data-aos-delay={100}
            >
              빠르고 합리적으로 계약을 도와드립니다.
            </h2>
          </div>
        </div>
      </div>
      <div className="step_cont">
        <div className="container">
          <div className="title">
            <span
              data-aos="fade-up"
              data-aos-duration={1500}
              data-aos-delay={100}
            >
              Fast Contract
            </span>
            <h2
              data-aos="fade-up"
              data-aos-duration={1500}
              data-aos-delay={200}
            >
              비상주 사무실 계약하기
            </h2>
            <p data-aos="fade-up" data-aos-duration={1500} data-aos-delay={300}>
              작성 하시면 계약서에 자동으로 반영 됩니다.
            </p>
          </div>
          <div
            className="form_box"
            data-aos="fade-up"
            data-aos-duration={1500}
            data-aos-delay={400}
          >
            <form>
              <div className="form_row">
                <div className="form_col">
                  <p>선택 상품명</p>
                  <div className="input_box">
                      <input
                        type="text"
                        defaultValue={productCodes.find(r => r.code === productCode)?.name}
                        disabled
                      />
                  </div>
                </div>
              </div>
              <div className="form_row">
                <div className="form_col">
                  <p>
                    계약 지점명<span className="essential">*</span>
                  </p>
                  <div className="input_box">
                    <label>
                      <select
                        id="branchSelect"
                        value={branchId}
                        onChange={(e) => set_branchId(+e.target.value)}
                      >
                        {branches.length === 0 ? <option value={-1}>계약 가능한 지점이 없습니다</option> : null}
                        {branches.map((b) => (
                          <option key={b.id} value={b.id}>
                            {b.branchName}
                          </option>
                        ))}
                      </select>
                    </label>
                  </div>
                </div>
              </div>
              <div className="form_row">
                <div className="form_col">
                  <p>
                    대표자명<span className="essential">*</span>
                  </p>
                  <div className="input_box">
                    <label>
                      <input type="text" maxLength={32}
                        name='repName'
                        defaultValue={order.repName}
                        ref={el => inputsRef.current['repName'] = el}
                        onChange={handleChange}
                      />
                    </label>
                  </div>
                </div>
                <div className="form_col">
                  <p>
                    대표자 연락처<span className="essential">*</span>
                  </p>
                  <div className="input_box">
                    <label>
                      <input type="tel" maxLength={11}
                        name='repPhone'
                        defaultValue={order.repPhone}
                        ref={el => inputsRef.current['repPhone'] = el}
                        onChange={handleChange}
                      />
                    </label>
                  </div>
                </div>
              </div>
              <div className="form_row">
                <div className="form_col">
                  <p>
                    담당자명<span className="essential">*</span>
                  </p>
                  <div className="input_box">
                    <label>
                      <input type="text"  maxLength={32}
                        name='contactName'
                        defaultValue={order.contactName}
                        ref={el => inputsRef.current['contactName'] = el}
                        onChange={handleChange}
                      />
                    </label>
                  </div>
                </div>
                <div className="form_col">
                  <p>
                    담당자 연락처<span className="essential">*</span>
                  </p>
                  <div className="input_box">
                    <label>
                      <input type="tel" maxLength={11}
                        name='contactPhone'
                        defaultValue={order.contactPhone}
                        ref={el => inputsRef.current['contactPhone'] = el}
                        onChange={e => handleChange(e)}
                      />
                    </label>
                  </div>
                </div>
              </div>
              <div className="form_row">
                <div className="form_col">
                  <p>
                    상호명<span className="essential">*</span>
                  </p>
                  <div className="input_box">
                    <label>
                      <input type="text" maxLength={32}
                        name='comapanyName'
                        defaultValue={order.companyName}
                        ref={el => inputsRef.current['companyName'] = el}
                        onChange={e => handleChange(e)}
                      />
                    </label>
                  </div>
                </div>
                <div className="form_col">
                  <p>
                    업종<span className="essential">*</span>
                  </p>
                  <div className="input_box">
                    <label>
                      <input type="text" maxLength={32}
                        name='industry'
                        defaultValue={order.industry}
                        ref={el => inputsRef.current['industry'] = el}
                        onChange={e => handleChange(e)}
                      />
                    </label>
                  </div>
                </div>
              </div>
              <div className="form_row">
                <div className="form_col">
                  <p>
                    이메일<span className="essential">*</span>
                  </p>
                  <div className="input_box">
                    <label>
                      <input type="email" maxLength={32}
                        name='email'
                        defaultValue={order.email}
                        ref={el => inputsRef.current['email'] = el}
                        onChange={e => handleChange(e)}
                      />
                    </label>
                  </div>
                </div>
                <div className="form_col">
                  <p>
                    주민등록번호<span className="essential">*</span>
                  </p>
                  <div className="input_box">
                    <label>
                      <input type="text" maxLength={6}
                        name='civilNum1'
                        defaultValue={order.civilNum1}
                        ref={el => inputsRef.current['civilNum1'] = el}
                        onChange={e => handleChange(e)}
                      />
                    </label>
                  </div>
                  <span>-</span>
                  <div className="input_box">
                    <label>
                      <input type="text" maxLength={7}
                        name='civilNum2'
                        defaultValue={order.civilNum2}
                        ref={el => inputsRef.current['civilNum2'] = el}
                        onChange={e => handleChange(e)}
                      />
                    </label>
                  </div>
                </div>
              </div>
              <div className="form_row postcode">
                <div className="form_col">
                  <p>
                    우편 번호<span className="essential">*</span>
                  </p>
                  <div className="input_box">
                    <label>
                      <input type="text" id="custom_postcode" readOnly
                        defaultValue={order.zipCode}
                        ref={el => inputsRef.current['zipCode'] = el}
                      />
                    </label>
                  </div>
                </div>
                <button type="button" onclick="custom_execDaumPostcode()"
                  onClick={() => {
                    dgRef.current.open()
                  }}
                >
                  주소 검색
                </button>
              </div>
              <div className="form_row">
                <div className="form_col">
                  <p>
                    기본 주소<span className="essential">*</span>
                  </p>
                  <div className="input_box">
                    <label>
                      <input type="text" id="custom_address" readOnly
                        defaultValue={order.addr1}
                        ref={el => inputsRef.current['addr1'] = el}
                      />
                    </label>
                  </div>
                </div>
              </div>
              <div className="form_row">
                <div className="form_col">
                  <p>
                    상세 주소<span className="essential">*</span>
                  </p>
                  <div className="input_box">
                    <label>
                      <input type="text" id="custom_detailAddress"
                        defaultValue={order.addr2}
                        ref={el => inputsRef.current['addr2'] = el}
                      />
                    </label>
                  </div>
                </div>
              </div>
              <div className="form_row radio">
                <div className="form_col">
                  <p>
                    사업자 유형<span className="essential">*</span>
                  </p>
                  <fieldset ref={el => inputsRef.current['bizCode'] = el}>

                    {/* <div className="input_box radio"> */}
                    {/* { */}
                    {/*   bizCodes.map((c, idx) => ( */}
                    {/*     <label key={idx}> */}
                    {/*       <input type="radio" id={c.code} name="bizCode" value={c.code}  */}
                    {/*         onChange={e => { */}
                    {/*           order.bizCode = c.code */}
                    {/*         }} */}
                    {/*       /> */}
                    {/*       <span>{c.name}</span> */}
                    {/*     </label> */}
                    {/*   )) */}
                    {/* } */}
                    {/* </div> */}

                    <div className="input_box radio">
                      <label>
                        <input type="radio" id="bt_1" name="bizCode" value='B001'
                          defaultChecked={order.bizCode == 'B001'}
                          onChange={e => {
                            order.bizCode = 'B001'
                          }}
                        />
                        <span>개인</span>
                      </label>
                      <label>
                        <input type="radio" id="bt_2" name="bizCode" value='B002'
                          defaultChecked={order.bizCode == 'B002'}
                          onChange={e => {
                            order.bizCode = 'B002'
                          }}

                        />
                        <span>법인</span>
                      </label>
                    </div>
                    {/**/}
                  </fieldset>
                </div>
              </div>
              <div className="form_row">
                <div className="form_col">
                  <p>
                    대표자 신분증<span className="essential">*</span>
                  </p>
                  <div className="input_box">
                    <label className="custom_file">
                      <span className="filename" >
                        {
                          idFiles.map((f, idx) =>(
                            <div key={idx}>{f.name}</div>
                          ))
                        }
                      </span>
                      <input type="file" id='idFiles' className="input_file" name="file" accept='.jpg, .jpeg, .png'
                        onChange={e => {
                          const files = [...e.target.files]
                          if(!checkFileSize(files, theme)) {
                            return
                          }
                          set_idFiles(files)
                        }}
                      />
                      <button type="button" id='idFilesButton' className="upload_btn"
                        onClick={(e) => {
                          e.stopPropagation()
                          document.getElementById('idFiles').click()
                        }}
                      >
                        파일 선택
                      </button>
                    </label>
                  </div>
                </div>
              </div>


              <div className="form_row" id="business_cert">
                <div className="form_col">
                  <p>
                    사업자등록증
                  </p>
                  <div className="input_box">
                    <label className="custom_file">
                      <span className="filename" >
                        {
                          bizFiles.map((f, idx) =>(
                            <div >{f.name}</div>
                          ))
                        }
                      </span>
                      <input type="file" id='bizFiles' className="input_file" name="file" accept='.jpg, .jpeg, .png'
                        onChange={e => {
                          const files = [...e.target.files]
                          if(!checkFileSize(files, theme)) {
                            return
                          }
                          set_bizFiles(files)
                        }}

                      />
                      <button type="button" className="upload_btn"
                        onClick={(e) => {
                          e.stopPropagation()
                          document.getElementById('bizFiles').click()
                        }}
                      >
                        파일 선택
                      </button>
                    </label>
                  </div>
                </div>
              </div>
              <div className="form_row" id="business_num">
                <div className="form_col">
                  <p>
                    사업자등록번호
                  </p>
                  <div className="input_box">
                    <label>
                      <input type="text" maxLength={3}
                        name="bizNum1"
                        defaultValue={order.bizNum1}
                        ref={el => inputsRef.current['bizNum1'] = el}
                        onChange={e => handleChange(e)}

                      />
                    </label>
                  </div>
                  <span>-</span>
                  <div className="input_box">
                    <label>
                      <input type="text" maxLength={2}
                        name="bizNum2"
                        defaultValue={order.bizNum2}
                        ref={el => inputsRef.current['bizNum2'] = el}
                        onChange={e => handleChange(e)}
                      />
                    </label>
                  </div>
                  <span>-</span>
                  <div className="input_box">
                    <label>
                      <input type="text" maxLength={5}
                        name="bizNum3"
                        defaultValue={order.bizNum3}
                        ref={el => inputsRef.current['bizNum3'] = el}
                        onChange={e => handleChange(e)}
                      />
                    </label>
                  </div>
                </div>
              </div>
              <div className="form_row" id="corp_cert">
                <div className="form_col">
                  <p>
                    법인등기부등본
                  </p>
                  <div className="input_box">
                    <label className="custom_file">
                      <div className="filename" style={{height:'inherit'}}>
                        {
                          corpFiles.map((f, idx) =>(
                            <div key={idx}>{f.name}</div>
                          ))
                        }

                      </div>
                      <input type="file" id='corpFiles' className="input_file" name="file" accept='.jpg, .jpeg, .png' multiple
                        onChange={e => {
                          const files = [...e.target.files]
                          if(!checkFileSize(files, theme)) {
                            return
                          }
                          set_corpFiles(files)
                        }}
                      />
                      <button type="button" className="upload_btn"
                        onClick={(e) => {
                          e.stopPropagation()
                          document.getElementById('corpFiles').click()
                        }}
                      >
                        파일 선택
                      </button>
                    </label>
                  </div>
                </div>
              </div>
              <div className="form_row" id="corp_num">
                <div className="form_col">
                  <p>
                    법인등록번호
                  </p>
                  <div className="input_box">
                    <label>
                      <input
                        type="text"
                        id="resident_number"
                        onkeyup="setBubin(this)"
                        name = "corpNum1"
                        maxLength={6}
                        defaultValue={order.corpNum1}
                        ref={el => inputsRef.current['corpNum1'] = el}
                      />
                    </label>
                  </div>
                  <span>-</span>
                  <div className="input_box">
                    <label>
                      <input
                        type="text"
                        id="resident_number"
                        onkeyup="setBubin(this)"
                        name = "corpNum2"
                        maxLength={7}
                        defaultValue={order.corpNum2}
                        ref={el => inputsRef.current['corpNum2'] = el}

                      />
                    </label>
                  </div>
                </div>
              </div>
              <div className="form_row" id="attorney">
                <div className="form_col">
                  <p>
                    대리인 위임장
                  </p>
                  <div className="input_box use_info">
                    <label className="custom_file">
                      <span className="filename" >
                        {
                          agencyFiles.map((f, idx) =>(
                            <div key={idx}>{f.name}</div>
                          ))
                        }

                      </span>
                      <input type="file" id='agencyFiles' className="input_file" name="file"  accept='.jpg, .jpeg, .png'
                        onChange={e => {
                          const files = [...e.target.files]
                          if(!checkFileSize(files, theme)) {
                            return
                          }
                          set_agencyFiles(files)
                        }}

                      />
                      <button type="button" className="upload_btn"
                        onClick={() => {
                          document.getElementById('agencyFiles').click()
                        }}
                      >
                        파일 선택
                      </button>
                    </label>
                    <span>* 대리인일 경우 첨부해 주세요.</span>
                  </div>
                </div>
              </div>
              <div className="form_row radio">
                <div className="form_col">
                  <p>
                    우편물 대리 개봉 및 메일 발송 서비스
                    <span className="essential">*</span>
                  </p>
                  <div className="input_box use_info">
                    <div className="custom_radio radio">
                      <label>
                        <input
                          type="radio"
                          name="mail_agree"
                          defaultChecked={order.emailSvcYn === 'Y'}
                          onChange={e => {
                            order.emailSvcYn = 'Y'
                          }}
                        />
                        <span>신청</span>
                      </label>
                      <label>
                        <input type="radio" name="mail_agree"
                          defaultChecked={order.emailSvcYn === 'N'}
                          onChange={e => {
                            order.emailSvcYn = 'N'
                          }}
                        />
                        <span>미신청</span>
                      </label>
                    </div>
                    <span>* 미신청 시 메일발송 서비스가 제공되지 않습니다.</span>
                  </div>
                </div>
              </div>
              <div className="form_row radio">
                <div className="form_col">
                  <p>
                    우편물, 택배 보관 기간 초과 시 폐기 동의
                    <span className="essential">*</span>
                  </p>
                  <div className="input_box use_info">
                    <div className="custom_radio radio">
                      <label>
                        <input
                          type="radio"
                          name="mail_dispose"
                          defaultChecked={order.destroySvcYn === 'Y'}
                          onChange={e => {
                            order.destroySvcYn = 'Y'
                          }}
                        />
                        <span>동의</span>
                      </label>
                      <label>
                        <input type="radio" name="mail_dispose"
                          defaultChecked={order.destroySvcYn === 'N'}
                          onChange={e => {
                            order.destroySvcYn = 'N'
                          }}
                        />
                        <span>미동의</span>
                      </label>
                    </div>
                    <span>* 미동의 시 계약이 불가 합니다.</span>
                  </div>
                </div>
              </div>
              <div className="form_row radio">
                <div className="form_col">
                  <p>
                    알게되신 경로<span className="essential">*</span>
                  </p>
                  <div className="input_box radio">
                    {
                      channelCodes.map((c, idx) => (
                        <label key={idx}>
                          <input type="radio" name="known"
                            defaultChecked={order.channelCode === c.code}
                            onChange={(e) => {
                              order.channelCode = c.code
                            }}
                          />
                          <span>{c.name}</span>
                        </label>
                      ))
                    }

                    {/* <label> */}
                    {/*   <input type="radio" name="known" /> */}
                    {/*   <span>네이버 검색</span> */}
                    {/* </label> */}
                    {/* <label> */}
                    {/*   <input type="radio" name="known" /> */}
                    {/*   <span>구글 검색</span> */}
                    {/* </label> */}
                    {/* <label> */}
                    {/*   <input type="radio" name="known" /> */}
                    {/*   <span>지인 추천</span> */}
                    {/* </label> */}
                    {/* <label> */}
                    {/*   <input type="radio" name="known" /> */}
                    {/*   <span>기타</span> */}
                    {/* </label> */}
                  </div>
                </div>
              </div>
              <div className="form_row radio">
                <div className="form_col">
                  <p>
                    개인정보 수집 및 이용동의
                    <span className="essential">*</span>
                  </p>
                  <div className="input_box use_info">
                    <div className="custom_radio radio">
                      <label>
                        <input type="radio" name="privacy"
                          defaultChecked = {order.privacyYn === 'Y'}
                          onChange={() => {
                            order.privacyYn = 'Y'
                          }}
                        />
                        <span>동의</span>
                      </label>
                      <label>
                        <input type="radio" name="privacy"
                          defaultChecked = {order.privacyYn === 'N'}
                          onChange={() => {
                            order.privacyYn = 'N'
                          }}
                        />
                        <span>미동의</span>
                      </label>
                    </div>
                    <span>
                      *{" "}
                      <a href="#privacy_modal" rel="modal:open">
                        [개인정보취급방침]
                      </a>{" "}
                      확인
                    </span>
                  </div>
                </div>
              </div>
              <div className="btn_box">
                <a href="/" className="cancle_btn btn">
                  취소
                </a>
                <button
                  type="button"
                  className="submit_btn btn"
                  onClick={e => {
                    confirmRef.current?.click()
                  }}
                >
                  등록
                </button>
                <ConfirmDialog
                  btn={<Button ref={confirmRef} style={{display:'none'}}>확인</Button>}
                  title={'알림'}
                  content={'동일 사업자 번호로 기한이 도래하지 않은 계약이 있을 경우, 해당 계약의 종료일 이후 첫재날이 시작일로 계약이 작성됩니다.'}
                  bc={'primary'}
                  preHandle={async () => {
                    return fillData()
                  }}
                  perform={() => {
                    onNext()
                  }}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
      <Footer/>
      <div>
         {renderIndicator()}
      </div>
    </>
  );
};

export default Contract1;
